import React from 'react';

import classnames from 'classnames';

import { TertiaryButton } from 'components/uiLibrary/LinkButton';
import SpriteIcon from 'components/uiLibrary/SpriteIcon';
import Typography from 'components/uiLibrary/Typography';

import { COMPONENTS } from 'components/Globals/Analytics/constants';

import { EVENTS, TP } from 'constants/index';

import { dispatchEvent } from 'utils/event';
import useAppContext from 'utils/hooks/useAppContext';

import { useTranslation } from 'src/i18n';

import { CASTING_RESULT_TYPES_VALUES } from 'operabase-router/constants';

import classes from './AddAnotherRole.module.scss';

const AddAnotherRole = ({ sticky = false, trackingData = {} }) => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const { obRouteContext } = useAppContext();
  const { linkProps } = obRouteContext;
  const { tab } = linkProps || {};
  const isRoleDebutTab = tab === CASTING_RESULT_TYPES_VALUES.ROLE_DEBUT;

  return (
    <TertiaryButton
      size={12}
      styles={{ root: classnames(classes.addRoleBtn, { [classes.sticky]: sticky }) }}
      onClick={() => {
        dispatchEvent(EVENTS.ADD_ANOTHER_ROLE);

        if (sticky && typeof window !== 'undefined') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }}
      trackingData={{
        ...trackingData,
        component: COMPONENTS.ADD_ANOTHER_ROLE,
      }}
    >
      {sticky && (
        <SpriteIcon
          icon="comedy_mask"
          size={14}
          className={classnames(classes.redMaskIcon, { [classes.stickyIcon]: sticky })}
        />
      )}
      {!sticky ? (
        <Typography weight="medium" size={12}>
          <SpriteIcon
            icon="comedy_mask"
            size={14}
            className={classnames(classes.redMaskIcon, { [classes.stickyIcon]: sticky })}
          />
          {isRoleDebutTab ? t(`${TP}.SHOULD_HAVE_PERFORMED`) : t(`${TP}.FN_ADD_ANOTHER_ROLE`)}
        </Typography>
      ) : null}
      <SpriteIcon
        icon="add_circle"
        size={14}
        className={classnames(classes.addCircleIcon, { [classes.stickyIcon]: sticky })}
      />
    </TertiaryButton>
  );
};

export default AddAnotherRole;
